module.exports = __webpack_public_path__ + "static/media/9.d8811f19.jpeg";